import API from "../../api/api";

const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const CrmService = {
    crmTiles: async () => {
        return callApi("crm-tiles");
    },
    crmGraph: async () => {
        return callApi("crm-graph");
    },
    followupToday: async (page, itemsPerPage) => {
        return callApi(`crm-followups-today?page=${page}&perPage=${itemsPerPage}`);
    },
    recentLeads: async (page, itemsPerPage) => {
        return callApi(`crm-recent-leads?page=${page}&perPage=${itemsPerPage}`);
    },
    missedFollowup: async (page, itemsPerPage) => {
        return callApi(`crm-missed-followups?page=${page}&perPage=${itemsPerPage}`);
    },
    viewLeads: async (tag, addedFromDate, addedToDate, nextToDate, nextFromDate, levelOfInterest="all", country, leadStatus="all", statusFromDate, statusToDate) => {
        return callApi(`view-crm-leads?tag=${tag}&status=${leadStatus}&nextFollowupToDate=${nextToDate}&nextFollowupFromDate=${nextFromDate}&addedDateFrom=${addedFromDate}&addedDateTo=${addedToDate}&levelofIntereset=${levelOfInterest}&statusChangeDateFrom=${statusFromDate}&statusChangeDateTo=${statusToDate}&country=${country}`);
    },
    editCrmLead: async (updatedLead) => {
        return API.patch(`edit-crm-lead`,updatedLead)
    }
}

export default CrmService
